






































































import Vue from 'vue';
import Component from 'vue-class-component';

import { mapActions } from 'vuex';

import SubHeader from '@/components/maternite/calendrier/Subheader.vue';
import Ligne from '@/components/maternite/calendrier/Ligne.vue';
import CommonSubheader from '@/components/maternite/calendrier/CommonSubheader.vue';

import { LigneCalendrier } from '@/types';

import dateGrossesseService from '@/services/dateGrossesseService.ts';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { log } from 'util';
import { content } from 'html2canvas/dist/types/css/property-descriptors/content';

const Props = Vue.extend({
	props: {
		//date presumee grossesse
		dpg: {
			type: String,
			default: ''
		}
	}
});

/** Calendrier page */
@Component({
	components: {
		SubHeader,
		CommonSubheader,
		Ligne
	}
})
export default class Calendrier extends Props {

	moisEnCours = dateGrossesseService.moisAffichage(this.dpg);

	imprimerCalendrier() {

		/** Le contenu a afficher */
		var contentEl = this.$refs.content as HTMLElement;
		var contentElEnfant = this.$refs.contentEnfant as HTMLElement;

		/** initialisation du PDF */
		const doc = new jsPDF('p', 'px', 'a4');
		var nbPages = 1;

		/** impressions enchainees dans le pdf de chaque element */
		this.imprimerContenu(contentEl, doc, true, nbPages).then(() => {
			/** le contenu de l'enfant est sur la page 2 */
			nbPages++;
			this.imprimerContenu(contentElEnfant, doc, false, nbPages).then(() => {
				/** lorsque tout est ok, on imprime le pdf */
				doc.save('MonCalendrierDeSuivi.pdf');
			});
		});

	}

	imprimerContenu(contenuAImprimer: HTMLElement, doc: jsPDF, ajoutEnTete: boolean, nbPages: number) {
		return new Promise(resolve => {
			/** Initialisation du canvas pour conversion html->canvas */
			var canvasElement = document.createElement('canvas');

			/** taille du canvas (avec ajout de la hauteur de l'entete)**/
			canvasElement.height = contenuAImprimer.scrollHeight;

			if (ajoutEnTete) {
				canvasElement.height += 125;
			}
			canvasElement.width = contenuAImprimer.clientWidth;
			/** fond blanc **/
			var ctx = canvasElement.getContext('2d');
			if (ctx != null) {
				ctx.fillStyle = 'white';
				ctx.fillRect(0, 0, canvasElement.width, canvasElement.height);
			}

			var width = doc.internal.pageSize.getWidth();
			var height = doc.internal.pageSize.getHeight();

			/** marge du pdf par rapport à celle de la maquette (220px pour une largeur totale de 1240px) **/
			var rightMarginPdf = Math.round((220*width)/1240);
			/** marge du pdf par rapport à celle de la maquette (173px pour une hauteur totale de 1755px) **/
			var topMarginPdf = Math.round((173*height)/1755);

			/** largeur de l'image par rapport au marge */
			var imgPdfWidth = Math.round(width - (rightMarginPdf*2));
			/** on garde le ratio de l'image pour le rendu */
			var imgPdfHeight = Math.round((imgPdfWidth*canvasElement.height)/canvasElement.width);

			html2canvas(contenuAImprimer, { canvas: canvasElement, logging: false, scale:1, onclone: function(document) {
					/** ajout de l'entete */
					if (ajoutEnTete) {
						var printSubElClone = document.getElementById('printSub');
						if (printSubElClone != null) {
							printSubElClone.classList.remove('d-none');
						}
					}
				}}).then(function(canvas) {
				const img = canvas.toDataURL('image/jpeg', 1);
				/** si ce n'est pas la premiere page, on ajoute une page */
				if (nbPages>1) {
					doc.addPage();
				}
				doc.addImage(img,'JPEG',rightMarginPdf,topMarginPdf,imgPdfWidth,imgPdfHeight);
				/** la promise est resolue :) */
				resolve('resolved');
			});
		});
	}

}
